<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
      <div slot="waitDeal" slot-scope="prop">
        <el-checkbox
          label="待我处理"
          name="type"
          v-model="prop.form.waitDeal"
        />
      </div>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        stateOptions: [], // 上报状态
        form: [
          { // 待我处理
            label: '待我处理',
            value: 'waitDeal',
            default: true,
            slot: true,
          },
          { // 订单号码
            label: '订单号码',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 司机姓名
            label: '司机姓名',
            value: 'userName',
            type: 'input',
            placeholder: '请输入司机姓名',
          },
          { // 上报状态
            label: '上报状态',
            value: 'state',
            type: 'select',
            default: -1,
            placeholder: '请选择上报状态',
          },
          { // 手机号码
            label: '手机号码',
            value: 'linkPhone',
            type: 'input',
            placeholder: '请输入手机号码',
          },
          { // 提交时间
            label: '提交时间',
            value: 'Time',
            type: 'date',
            default: [],
            placeholder: '请选择提交时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 提交人
            label: '提交人',
            value: 'subUserName',
            type: 'input',
            placeholder: '请输入提交人',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.Time && searchBoxData.Time.length) {
        searchBoxData.startTime = this.formatDate(searchBoxData.Time[0], 1);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1], 1);
      }
      delete searchBoxData.Time;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'ORDER_COST_REPORT_STATE',
    });
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
